export default __webpack_public_path__ + "static/media/arrayTwo.79207cf1.svg";